<template>
  <div class="plateorder">
    <ul class="plateorder-tabs-boxs vue_flex">
      <li
        class="vue_relative h"
        :class="activeName === tabs.activeVal ? 'active' : 'activenot'"
        v-for="(tabs, tabsIndex) in tabsList"
        :key="tabsIndex"
        @click="handleClick(tabs)"
      >
        <p class="vue-font-PingFang-bold">{{ tabs.title }}</p>
        <div class="vue_absolute" v-if="activeName === tabs.activeVal"></div>
      </li>
    </ul>

    <div class="plateorder-tabs vue_flex vue_flex_between vue_align_center">
      <div
        class="plateorder-tabs-input vue_flex vue_align_center vue_flex_between width_100"
      >
        <!-- <div class="top_bar_inp vue_flex vue_align_center">
          <img
            class="top_bar_inp_img1 h"
            src="../../../../../assets/yimou/ss.png"
            alt=""
          />
          <input
            type="text"
            class="top_bar_inp_inp"
            v-model="searchValue"
            placeholder="搜索SKU名称、ID"
          />
        </div> -->
        <div class="vue_flex">
          <!-- <div
            class="plateorder-tabs-input-history vue-font-PingFang-400 color_35 h"
            @click="dialogimportVisible = true"
          >
            批量计算历史订单
          </div> -->
          <div
            class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h"
            @click="dialogimportVisible = true"
          >
            新建模板
          </div>
        </div>
      </div>
    </div>

    <div class="width_100">
      <!-- @selection-change="handleSelectionChange" -->
      <el-table
        :data="dataList"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headercellstyle"
        border
        height="62vh"
        :key="'deliveryTable'"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="name" label="模板名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.name }}
            <!-- <el-tag>默认</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column prop="lationnum" label="关联商品数" align="center">
          <template slot-scope="scope">
            {{ scope.row.data.length }}
          </template></el-table-column
        >
        <el-table-column
          prop="updatetime"
          label="最后编辑时间"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="row">
            <!-- <el-button type="text" @click="handleEdit(row)">编辑</el-button> -->
            <!-- <el-button type="text">复制</el-button>
            <el-button type="text">取消默认模板</el-button>
            <el-button type="text" @click="handleDelete(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getHetongListFun"
    />

    <el-dialog
      :visible.sync="dialogimportVisible"
      custom-class="unique-dialog"
      width="752px"
      :close-on-click-modal="false"
      :show-close="false"
      top="5vh"
    >
      <div class="import-mask vue_flex vue_align_center vue_column">
        <div
          class="import-mask-title vue-font-PingFang-500 color_255 vue_relative"
        >
          新建包装费模板
          <img
            src="../../../../../assets/yimou/gb.png"
            alt=""
            class="vue_absolute h"
            @click="dialogimportVisible = false"
          />
        </div>
        <div class="import-mask-boxs vue_flex vue_column">
          <div class="import-mask-boxs-inp">
            <ul class="vue_flex vue_align_center">
              <li class="vue_flex vue-font-PingFang-500">
                <span>*</span>
                <p class="color_35">模版名称</p>
              </li>
              <li class="import-mask-ul-boxs">
                <input
                  type="text"
                  v-model="tempObj.name"
                  placeholder="请输入模板名称"
                  class="vue-font-PingFang-400 font18"
                />
              </li>
            </ul>
          </div>
          <div class="vue_flex vue_column">
            <p
              class="vue-font-PingFang-500 color_35 font20"
              style="margin-bottom: 26px"
            >
              计费规则类型
            </p>
            <el-radio-group v-model="tempObj.role">
              <el-radio label="1">重量计价</el-radio>
              <el-radio label="2">按件计价</el-radio>
              <el-radio label="3">订单金额计价(元)</el-radio>
            </el-radio-group>
          </div>
          <div v-if="tempObj.role != 3">
            <div class="vue_flex vue_column" style="margin-top: 29px">
              <p
                class="vue-font-PingFang-500 color_35 font20"
                style="margin-bottom: 26px"
              >
                计费方式
              </p>
              <el-radio-group v-model="tempObj.jijiatype">
                <el-radio label="1">单价</el-radio>
                <el-radio label="2">梯度计价</el-radio>
              </el-radio-group>
            </div>
            <div
              class="vue_flex vue_align_center"
              style="margin: 29px 0px 42px"
              v-if="tempObj.jijiatype === '1'"
            >
              <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                每kg价格
              </p>
              <input type="text" class="kgprice" v-model="tempObj.price" />
              <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                元
              </p>
            </div>
            <template v-if="tempObj.jijiatype === '2'">
              <div class="billing-boxs vue_flex vue_flex_between">
                <p
                  v-if="activeName == 'delivery'"
                  class="vue-font-PingFang-400 color_35 font18 line_height_18"
                  style="width: 200px"
                >
                  城市
                </p>
                <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                  不超过(kg)
                </p>
                <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                  固定费用(元)
                </p>
                <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                  操作
                </p>
              </div>

              <div
                class="billing-boxs-data vue_flex vue_flex_between vue_align_center"
                v-for="(item, billingIndex) in tempObj.jieti"
              >
                <div style="width: 200px" v-if="activeName == 'delivery'">
                  <el-select v-model="item.city" placeholder="请选择">
                    <el-option
                      v-for="item in citylist"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>

                <input
                  type="text"
                  class="vue-font-PingFang-400 font18"
                  v-model="item.jieti1"
                />
                <input
                  type="text"
                  class="vue-font-PingFang-400 font18"
                  v-model="item.jieti2"
                />
                <div
                  class="vue_flex vue_flex_around"
                  @click="delejieti(billingIndex)"
                >
                  <img src="../../../../../assets/yimou/sc.png" alt="" />
                </div>
              </div>
              <div
                @click="addjifei"
                class="billing-boxs-add vue_flex vue_flex_around vue_align_center"
              >
                <div class="vue_flex vue_align_center">
                  <img src="../../../../../assets/yimou/jh.png" alt="" />
                  <p
                    class="vue-font-PingFang-400 color_35 font18 line_height_18"
                  >
                    添加计费组
                  </p>
                </div>
              </div>
              <div
                class="billing-boxs-sealce vue_flex vue_flex_between vue_align_center"
              >
                <el-radio-group v-model="tempObj.jijiatype1">
                  <el-radio label="1">
                    固定价格
                    <input
                      type="text"
                      class="vue-font-PingFang-400 font18"
                      v-model="tempObj.jieti3"
                    />
                    <span>元</span>
                  </el-radio>
                  <el-radio label="2">
                    每增加1kg，增加
                    <input
                      type="text"
                      class="vue-font-PingFang-400 font18"
                      v-model="tempObj.jieti4"
                    />
                    <span>元</span>
                  </el-radio>
                </el-radio-group>
              </div>
            </template>
          </div>
          <div v-else>
            <div
              class="billing-boxs-sealce vue_flex vue_flex_between vue_align_center"
            >
              <el-radio-group v-model="tempObj.jijiatype2">
                <el-radio label="1">
                  每笔子订单固定
                  <input type="text" class="vue-font-PingFang-400 font18" />
                  <span>元</span>
                </el-radio>
                <el-radio label="2">
                  子订单金额
                  <input type="text" class="vue-font-PingFang-400 font18" />
                  <span>%</span>
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div
          class="import-mask-but vue-font-PingFang-500 color_255 h"
          @click="addmoban"
        >
          确认
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
  components: { Pagination },
  data() {
    return {
      citylist: [
        { id: "全国", value: "全国" },
        { id: "北京市", value: "北京市" },
        { id: "天津市", value: "天津市" },
        { id: "上海市", value: "上海市" },
        { id: "重庆市", value: "重庆市" },
        { id: "河北省", value: "河北省" },
        { id: "山西省", value: "山西省" },
        { id: "辽宁省", value: "辽宁省" },
        { id: "吉林省", value: "吉林省" },
        { id: "黑龙江省", value: "黑龙江省" },
        { id: "江苏省", value: "江苏省" },
        { id: "浙江省", value: "浙江省" },
        { id: "安徽省", value: "安徽省" },
        { id: "福建省", value: "福建省" },
        { id: "江西省", value: "江西省" },
        { id: "山东省", value: "山东省" },
        { id: "河南省", value: "河南省" },
        { id: "湖北省", value: "湖北省" },
        { id: "湖南省", value: "湖南省" },
        { id: "广东省", value: "广东省" },
        { id: "海南省", value: "海南省" },
        { id: "四川省", value: "四川省" },
        { id: "贵州省", value: "贵州省" },
        { id: "云南省", value: "云南省" },
        { id: "陕西省", value: "陕西省" },
        { id: "甘肃省", value: "甘肃省" },
        { id: "青海省", value: "青海省" },
        { id: "台湾省", value: "台湾省" },
        { id: "内蒙古自治区", value: "内蒙古自治区" },
        { id: "广西壮族自治区", value: "广西壮族自治区" },
        { id: "西藏自治区", value: "西藏自治区" },
        { id: "宁夏回族自治区", value: "宁夏回族自治区" },
        { id: "新疆维吾尔自治区", value: "新疆维吾尔自治区" },
        { id: "香港特别行政区", value: "香港特别行政区" },
        { id: "澳门特别行政区", value: "澳门特别行政区" },
      ],
      tempObj: {
        name: "",
        role: "",
        jijiatype: "",
        jijiatype1: "",
        jijiatype3: "",
        jieti4: "",
        jieti3: "",
        price: "",
        jieti: [],
        data: "",
      },
      innerWidth: 0,
      innerHeight: 0,
      headercellstyle: {
        backgroundColor: "rgba(245, 247, 250, 1)",
        color: "rgba(51, 3, 0, 1)",
      },

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      dialogimportVisible: false,

      activeName: "delivery",
      tabsList: [
        { title: "快递费", activeVal: "delivery" },
        { title: "包装费", activeVal: "packa" },
        { title: "赠品费", activeVal: "freegift" },
        // { title: "特殊佣金", activeVal: "special" },
        // { title: "税费", activeVal: "taxes" },
      ],

      searchValue: "",
      dataList: [],
      billing: "1",
      price: "",
      taobaoList: [],

      jingdongList: [],

      pduoduoList: [],

      billingList: [{}, {}],
    };
  },

  created() {
    this.innerWidth = windowFun().innerWidth;
    this.innerHeight = windowFun().innerHeight;
    this.activeFun();
  },

  methods: {
    delejieti(ind) {
      this.tempObj.jieti.splice(ind, 1);
    },
    addjifei() {
      let item = {
        jieti1: "",
        jieti2: "",
        city: "",
      };
      this.$nextTick(() => {
        this.tempObj.jieti.push(item);
      });
    },
    async addmoban() {
      let params = {};
      if (this.activeName == "packa" || this.activeName == "freegift") {
        // 包装费
        params = {
          type: this.activeName == "packa" ? "2" : "3",
          name: this.tempObj.name,
          role: this.tempObj.role,
          jijiatype: this.tempObj.jijiatype,
        };
        if (this.tempObj.jijiatype == 1) {
          //单价
          params["data"] = [
            {
              price: this.tempObj.price,
            },
          ];
        }
        if (this.tempObj.jijiatype == 2) {
          //阶梯价
          params["data"] = [];
          for (let i in this.tempObj.jieti) {
            let item = {
              type: "1",
              weight: this.tempObj.jieti[i].jieti1,
              price: this.tempObj.jieti[i].jieti2,
            };
            params.data.push(item);
          }

          if (this.tempObj.jijiatype1 == "1") {
            let item = {
              type: "2",
              price: this.tempObj.jieti3,
            };
            params.data.push(item);
          }
          if (this.tempObj.jijiatype1 == "2") {
            let item = {
              type: "3",
              price: this.tempObj.jieti4,
            };
            params.data.push(item);
          }
        }
        params.data = JSON.stringify(params.data);

        const res = await this.$http.post(
          this.$urls.addbaozhuangzengpintemplate,
          params
        );
        if (res.errcode != 0) return DonMessage.error(res.errmsg);
        this.tempObj = {
          name: "",
          role: "",
          jijiatype: "",
          jijiatype1: "",
          jijiatype3: "",
          jieti4: "",
          jieti3: "",
          price: "",
          jieti: [],
          data: "",
        };
        this.dialogimportVisible = false;
        this.activeFun();
      }
      if (this.activeName == "delivery") {
        // 快递
        params = {
          name: this.tempObj.name,
          role: this.tempObj.role,
          jijiatype: this.tempObj.jijiatype,
        };
        if (this.tempObj.jijiatype == 1) {
          //单价
          params["data"] = [
            {
              price: this.tempObj.price,
            },
          ];
        }
        if (this.tempObj.jijiatype == 2) {
          //阶梯价
          params["data"] = [];
          for (let i in this.tempObj.jieti) {
            let item = {
              type: "1",
              weight: this.tempObj.jieti[i].jieti1,
              price: this.tempObj.jieti[i].jieti2,
              province: this.tempObj.jieti[i].city,
            };
            params.data.push(item);
          }

          if (this.tempObj.jijiatype1 == "1") {
            let item = {
              type: "2",
              price: this.tempObj.jieti3,
            };
            params.data.push(item);
          }
          if (this.tempObj.jijiatype1 == "2") {
            let item = {
              type: "3",
              price: this.tempObj.jieti4,
            };
            params.data.push(item);
          }
        }
        params.data = JSON.stringify(params.data);
        const res = await this.$http.post(this.$urls.addkuaidirole, params);
        if (res.errcode != 0) return DonMessage.error(res.errmsg);
        this.tempObj = {
          name: "",
          role: "",
          jijiatype: "",
          jijiatype1: "",
          jijiatype3: "",
          jieti4: "",
          jieti3: "",
          price: "",
          jieti: [],
          data: "",
        };
        this.dialogimportVisible = false;
        this.activeFun();
      }
    },
    handleSelectionChange(e) {},

    handleClick(row) {
      if (this.activeName === row.activeVal) return;
      this.activeName = row.activeVal;
      this.activeFun();
    },

    async activeFun() {
      let ty = "";
      if (this.activeName == "delivery") ty = "1";
      if (this.activeName == "packa") ty = "2";
      if (this.activeName == "freegift") ty = "3";
      let params = {
        ...this.listQuery,
        type: ty,
      };
      const res = await this.$http.get(this.$urls.gettemplatelist, params);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dataList = res.list;
      this.total = res.count;
    },

    getHetongListFun() {},
  },
};
</script>

<style lang="scss" scoped>
.plateorder {
  padding: 22px;
}
.plateorder-tabs-boxs {
  gap: 68px;
  margin-bottom: 41px;
  li {
    p {
      font-size: 26px;
    }
    div {
      width: 100%;
      height: 3px;
      background: rgba(25, 92, 248, 1);
      border-radius: 2px;
      bottom: -12px;
      left: 0px;
    }
  }
  .active {
    color: rgba(25, 92, 248, 1);
  }
  .activenot {
    color: rgba(35, 35, 35, 1);
  }
}

.plateorder-tabs {
  background: rgba(245, 245, 245, 1);
  border-radius: 10px;
  padding: 9px 18px 8px 27px;
  margin-bottom: 28px;

  .plateorder-tabs-input {
    .top_bar_inp {
      width: 372px;
      height: 54px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      margin-right: 32px;
      padding: 0 11px;
      .top_bar_inp_img1 {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
      .top_bar_inp_inp {
        width: 282px;
      }
    }
    .plateorder-tabs-input-but {
      width: 131px;
      height: 54px;
      background: rgba(25, 92, 248, 1);
      border-radius: 10px;
      font-size: 20px;
      line-height: 54px;
      text-align: center;
    }
    .plateorder-tabs-input-history {
      width: 214px;
      height: 55px;
      line-height: 53px;
      text-align: center;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #999999;
      font-size: 20px;
      margin-right: 26px;
    }
  }
}

.import-mask {
  width: 100%;
  border-radius: 15px;
  background-image: url("../../../../../assets/yimou/tb.png");
  background-size: 100% 51px;
  background-repeat: no-repeat;
  padding-bottom: 40px;
  .import-mask-title {
    width: 100%;
    height: 51px;
    line-height: 51px;
    text-align: center;
    font-size: 18px;
    img {
      width: 13px;
      height: 13px;
      top: 21px;
      right: 20px;
    }
  }
  .import-mask-boxs {
    width: 650px;
    margin-top: 34px;
    .import-mask-boxs-inp {
      width: 100%;
      background: rgba(245, 245, 245, 1);
      border-radius: 10px;
      padding: 11px 22px;
      margin-bottom: 19px;
      ul {
        li:nth-of-type(1) {
          width: 145px;
          font-size: 18px;
          line-height: 18px;
          span {
            color: rgba(255, 0, 0, 1);
          }
        }
      }
    }
    .import-mask-boxs-upload {
      width: 100%;
      height: 168px;
      margin: 10px 0px 34px;
      background-image: url("../../../../../assets/yimou/hsk.png");
      img {
        width: 35px;
        height: 31px;
        margin-top: 39px;
      }
      .upload-title {
        font-size: 16px;
        line-height: 16px;
        margin: 16px 0px 13px;
        span:nth-of-type(2) {
          color: rgba(20, 75, 201, 1);
        }
      }
      .upload-content {
        font-size: 14px;
        line-height: 14px;
      }
    }
    .import-mask-ul-boxs {
      width: 24vw;
    }
  }
  .import-mask-but {
    width: 266px;
    height: 47px;
    line-height: 47px;
    text-align: center;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 17px;
  }
}

.import-mask-boxs-inp .el-input /deep/.el-input__inner {
  border: none !important;
  font-size: 18px;
}
.revenbook-drawer .el-input /deep/.el-input__inner {
  border: none !important;
  background: none !important;
  font-size: 18px;
}
.el-select {
  width: 100% !important;
}
.el-select /deep/.el-input__inner {
  width: 100%;
  border: none !important;
  background: none !important;
  font-size: 18px;
}
.el-select /deep/.el-select__caret {
  color: #000000 !important;
}
.upload-demo /deep/.el-upload-dragger {
  background: none !important;
  border: none !important;
  border-radius: 0px !important;
  width: 640px !important;
  height: 168px;
}

.kgprice {
  width: 129px;
  height: 41px;
  text-align: center;
  background: rgba(245, 245, 245, 1);
  border-radius: 5px;
  margin: 0px 13px 0px 10px;
}
.billing-boxs {
  margin: 18px 0px 12px;
  padding: 23px 0px 18px;
  background: rgba(244, 245, 249, 1);
  border-radius: 10px;
  p {
    width: 30%;
    text-align: center;
  }
}
.billing-boxs-data {
  margin-bottom: 20px;
  input {
    width: 30%;
    height: 46px;
    line-height: 46px;
    text-align: center;
    background: rgba(245, 245, 245, 1);
    border-radius: 10px;
  }
  div {
    width: 30%;
    img {
      width: 17px;
      height: 20px;
    }
  }
}
.billing-boxs-add {
  background: rgba(245, 245, 245, 1);
  border-radius: 10px;
  padding: 16px 0px;
  img {
    width: 21px;
    height: 22px;
    margin-right: 12px;
  }
}
.billing-boxs-sealce {
  margin: 32px 0px 29px;
  input {
    width: 129px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    background: rgba(245, 245, 245, 1);
    border-radius: 10px;
    margin: 0px 12px;
  }
  span {
    color: rgba(35, 35, 35, 1) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/goodsmanage/costorder/index.vue